<template>
  <li class="track-item trip-item" @click="$emit('select', trip.id)">
    <div v-if="trip.cover_photo_url" class="trip-cover">
      <img :src="trip.cover_photo_thumb_url || trip.cover_photo_url" :alt="trip.name" loading="lazy" />
    </div>
    <div class="track-item-title">{{ trip.name }}</div>
    <div class="track-item-meta">
      {{ formatTripDate(trip.trip_date) }} · {{ visibilityLabel(trip.public) }}
    </div>
    <div v-if="trip.author" class="track-item-meta">
      {{ trip.likes_count ?? 0 }} 👍 · {{ trip.dislikes_count ?? 0 }} 👎 · {{ trip.comments_count ?? 0 }} 💬
    </div>
    <div v-if="trip.author" class="track-item-meta track-item-author">
      <AuthorLink :author="trip.author" prefix="Автор:" size="sm" stop-propagation />
    </div>
    <div v-if="showDelete" class="btn-row" style="margin-top: 0.75rem">
      <button class="btn btn-danger" @click.stop="$emit('delete', trip.id)">
        Удалить
      </button>
    </div>
  </li>
</template>

<script setup>
import AuthorLink from './AuthorLink.vue'
import { formatTripDate, visibilityLabel } from '../utils/tripFormat'

defineProps({
  trip: {
    type: Object,
    required: true,
  },
  showDelete: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['select', 'delete'])
</script>

<style scoped>
.trip-cover {
  margin-bottom: 0.5rem;
  border-radius: 0.375rem;
  overflow: hidden;
  max-height: 120px;
}

.trip-cover img {
  display: block;
  width: 100%;
  height: 120px;
  object-fit: cover;
}
</style>
